
//import { Router } from '@angular/router';
import { TokenStorage } from '../../core/token.storage';
import { Injectable } from '@angular/core';

@Injectable()
export class CheckProfileService {
    
   

    constructor(private token: TokenStorage){}

    verifyProfile() {

      

        if (this.token.getUserProfile() != null) {
           
            //this.router.navigate(['login']); 
            ///console.log("Mon profil: ", this.token.getUserProfile());
           
       }
       else {
           
            //this.router.navigate(['login']); 
            ///console.log("Mon profil est null");
           
       }
        //return false;

        
       
    }

}


// WEBPACK FOOTER //
// ./src/app/common/services/check-profile.service.ts